import React, { useCallback, useMemo } from 'react';

// DEPENDENCIES
import format from 'date-fns/format';
import { useFormikContext } from 'formik';
import get from 'lodash/get';
import identity from 'lodash/identity';
import HTMLReactParser from 'html-react-parser';

// GLOBAL VARIABLES
import { DATE_FORMATS } from 'globals.js';

// GLOBAL FUNCTIONS
import { controlName } from 'functions';

// LOCAL COMPONENTS
import Form from 'core/form/Form';

// STYLES
import styles from './reviewChecklist.module.scss';

// VARIABLES
const TODAY = format(new Date(), DATE_FORMATS.spotDate);

// RENDER
const ReviewChecklist = ({
  name,
  filter = identity
}) => {

  // FORMIK
  const { values, setFieldValue } = useFormikContext() || {};

  // MEMOS
  const value = useMemo(
    () => get(values, name) || [],
    [name, values]
  )
  const checkList = useMemo(
    () => value.map((item, index) => ({...item, index})).filter(filter),
    [value, filter]
  )

  // CALLBACKS
  const handleChange = useCallback(
    i => setFieldValue(controlName('date_updated', name, i), TODAY),
    [name, setFieldValue]
  )

  // RENDER
  return Array.isArray(value) && checkList.map((item, i) => (
    <Form.YesNo
      key={i}
      name={controlName('is_completed', name, item.index)}
      label={{
        prefix: `${i + 1}. `,
        label: HTMLReactParser(item.checklist_text),
        className: styles.label,
        col: {
          className: styles.labelCol
        }
      }}
      onChange={() => handleChange(i)}
      numeric={false}
      required
    />
  ))
}

export default ReviewChecklist